<template>
  <p class="my-4">
    {{ t('yard.pages.yardView.messages.thisSpotIsOpenAndAvailableForTruckAssignment') }}
  </p>
</template>
<script>
import { defineComponent } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewSpotDetailOpen',
  setup() {
    const { t } = useI18n();
    const yardStore = useYard();

    return {
      t,
      isSpotOpen: yardStore.isSpotOpen,
      spot: yardStore.selectedSpotRef
    };
  }
});
</script>
<style scoped lang="scss"></style>
